<template>
    <div v-loading.fullscreen.lock="loading">
        <department-search-bar-component
            add_auth="新增部门"
            :fAllenterprise="fAllenterprise"
            @search="get_department_index"
            @addTeam="addTeam"
        ></department-search-bar-component>
        <common-table-component
            details_auth="部门详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_department"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_department_index"
        ></common-page-component>
        <department-edit-component
            edit_auth="修改部门"
            del_auth="删除部门"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :department_details_data="fdepartment_details_data"
            :foptions="foptions"
            :fAllenterprise="fAllenterprise"
            @exitDepartmentDialog="dialogExit"
            @search="get_department_index"
            @fenterpriseChange="staff_list_request"
            @show_edit="show_edit"
            @details_row="details_department"
        ></department-edit-component>
    </div>
</template>

<script>
import { department_index_request,department_details_request } from '@/network/department.js'
import { staff_list_request,enterprise_list_request } from '@/network/list.js'

import DepartmentSearchBarComponent from '@/components/department/DepartmentSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import DepartmentEditComponent from '@/components/department/DepartmentEditComponent'

export default {
    name: 'DepartmentView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                name: '',
                enterprise_id: '',
                director_name: '',
                status: 1,
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'name',
                    label: '部门名称',
                    minWidth: '150px'
                },
                {
                    prop: 'status',
                    label: '可用状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'danger',
                                filter_data: '禁用'
                            }
                        } else if(d===1) {
                            return {
                                type: 'success',
                                filter_data: '启用'
                            }
                        }
                    }
                },
                {
                    prop: 'director_name',
                    label: '部门负责人',
                    minWidth: '120px'
                },
                {
                    prop: 'enterprise_name',
                    label: '所属企业',
                    minWidth: '260px'
                },
            ],
            fdepartment_details_data: {},
            foptions: [],
            fAllenterprise: []
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_department_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.enterprise_id = param.enterprise_id ?? this.cond.enterprise_id
            this.cond.director_name = param.director_name ?? this.cond.director_name
            this.cond.status = param.status ?? this.cond.status
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            department_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_department(id) {
            this.fid = id
            this.fdialogFormVisible = true
            department_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fdepartment_details_data = s.result
                        //获取企业下的所有员工
                        staff_list_request({enterprise_id:s.result.enterprise_id})
                            .then((s) => {
                                this.foptions = s.result
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        staff_list_request(e) {
            staff_list_request({enterprise_id:e})
                .then((s) => {
                    this.foptions = s.result
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_all_enterprise() {
            enterprise_list_request()
                .then((s) => {
                    this.fAllenterprise = s.result
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
    },
    filters: {},
    props: {},
    created() {
        this.get_department_index()
        this.get_all_enterprise()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        DepartmentSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        DepartmentEditComponent,
    },
    watch: {},
}
</script>

<style lang='less'></style>